import { toast } from 'react-toastify';
import { KamaIcon } from '@kamatech-ir/kama-react-module';
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';

const publicKey =
  '-----BEGIN PUBLIC KEY-----\r\nMIGqAgEAAoGBAMZJs+/T2dE7sDAqm2TCbqhHmnRBRLOqRP2svtBSRpLzkwej7ccQ\r\nkP4Lm0VM+3D6JXErUbzb7XUfIIKaQmIKeJsNBlLTfA42b6ZbKlskJQ5L7/icxWeC\r\ntz7t+uCXMZ/wj4si7vO5ZNgK0RvNgfYOz1WUE/zLJ8syXaHPdjY2NbFBAgMBAAEC\r\nAwEAAQIDAQABAgMBAAECAwEAAQIDAQABAgMBAAE=\r\n-----END PUBLIC KEY-----\r\n';

function encode(model: any) {
  // if (process.env.REACT_APP_DEPLOY_MODE === 'dev') {
  //   return model;
  // }

  let maxLength = 55;
  let json = JSON.stringify(model);
  let hash = '';
  let loopLength = Math.ceil(json.length / maxLength);

  for (let i = 0; i < loopLength; i++) {
    var stratIndex = i * maxLength;
    let modelEncrypt = json.substr(stratIndex, maxLength);
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    var encrypted = encrypt.encrypt(modelEncrypt);
    hash += `${encrypted} `;
  }
  return { Hash: hash };
}
function encodeAesNoKey(model: any) {
  var k1 = model.slice(0, 4);
  model = model.slice(4);
  var k2 = '';
  var k3 = model.slice(-8);
  model = model.slice(0, -8);

  var t = Math.floor(model.length / 2);
  for (let i = t; i > 0; i--) {
    var c = model[i];
    if (c == '/') {
      var f = model.slice(i, i + 33);
      model = model.slice(0, i) + model.slice(i + 33);
      k2 = f.slice(-4);
      break;
    }
  }

  const k = k1 + k2 + k3;

  var key = CryptoJS.enc.Utf8.parse(k);
  var iv = CryptoJS.enc.Utf8.parse(k);

  var decryptStr = CryptoJS.AES.decrypt(model, key, {
    keySize: 128 / 8,
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);

  return decryptStr;
}

const alertHelper = (type: 'success' | 'warning' | 'error') => {
  return (message: string = '') => {
    if (message) {
      toast[type](message, {
        autoClose: 5e3,
        icon: ({ theme, type }) => {
          return (
            <KamaIcon
              icon={type === 'success' ? 'lock' : 'warning-alt'}
              colors={
                type === 'success'
                  ? { primaryColor: '#388e3c', secondaryColor: '#388e3c' }
                  : type === 'warning'
                  ? { primaryColor: '#e7c56e', secondaryColor: '#e7c56e' }
                  : { primaryColor: '#d32f2f', secondaryColor: '#d32f2f' }
              }
            />
          );
        },
      });
    }
  };
};
function processError(error: any, message = '') {
  if (error.constructor === Array) {
    return error.join('\n');
  } else if (['Error', 'AxiosError'].indexOf(error.constructor.name) !== -1) {
    return error.items ? error.items : error.message;
  } else if (error) {
    return error.message;
  } else {
    return message;
  }
}
function removeQueryParam(keyToRemove: string) {
  // Get the current query string
  const queryString = window.location.search;

  // Parse the query string into an object
  const params = new URLSearchParams(queryString);

  // Remove the desired key from the object
  params.delete(keyToRemove);

  // Create a new query string
  const newQueryString = params.toString();

  // Remove the question mark if the query string is empty
  const updatedQueryString = newQueryString ? `?${newQueryString}` : '';

  // Replace the current URL with the new query string
  window.history.replaceState(
    {},
    document.title,
    `${window.location.pathname}${updatedQueryString}`
  );
}
function formatSecondsToTimeString(seconds: number) {
  if (isNaN(seconds)) {
    return '00:00';
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
}

const tools = {
  alert: {
    success: alertHelper('success'),
    warning: alertHelper('warning'),
    error: alertHelper('error'),
  },
  processError,
  removeQueryParam,
  formatSecondsToTimeString,
  encode,
  encodeAesNoKey,
};

export default tools;
